// ROOMS
export const SET_ALL_ROOMS = 'SET_ALL_ROOMS';
export const SET_EMPTY_ROOMS = 'SET_EMPTY_ROOMS';
export const SET_CURRENT_ROOM = 'SET_CURRENT_ROOM';
export const SET_ROOM_MESSAGES = 'SET_ROOM_MESSAGES';
export const RESET_CURRENT_ROOM = 'RESET_CURRENT_ROOM';
export const RESET_ROOM_MESSAGES = 'RESET_ROOM_MESSAGES';

// USERS
export const SET_ALL_USERS = 'FETCH_ALL_USERS';
export const SET_CURRENT_USER_ID = 'GET_CURRENT_USER_ID';

// STATUSES & PARAMETERS
export const SET_STATS_PANEL_STATUS = 'CHANGE_STATS_PANEL_STATUS';
export const SET_LOADING_STATUS = 'SET_LOADING_STATUS';
export const SET_AMOUNT_OF_LETTERS = 'UPDATE_AMOUNT_OF_LETTERS';
export const SET_CONVERSER_LEFT_STATUS = 'SET_CONVERSER_LEFT_STATUS';
export const RESET_AMOUNT_OF_LETTERS = 'RESET_AMOUNT_OF_LETTERS';




